module.exports = __webpack_public_path__ + "img/Spring.90d4598e.png";